<template>
    <div class="dashboard-welcome">
        <h2>Dashboard</h2>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <div class="media dashboard-box">
                <div class="icon" style="background-color: #F44336;"><font-awesome-icon :icon="['fas', 'file-alt']" /></div>
                <div class="media-body">
                  <h3>Total Posts<small>{{ totalPostCount }}</small></h3>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="media dashboard-box">
                <div class="icon" style="background-color: #ff9800;"><font-awesome-icon :icon="['fas', 'eye']" /></div>
                <div class="media-body">
                  <h3>Post Views<small>{{ getTotalPostViews }}</small></h3>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="media dashboard-box">
                <div class="icon" style="background-color: #30cc7b;"><font-awesome-icon :icon="['fas', 'star']" /></div>
                <div class="media-body">
                  <h3>Ratings<small>{{ averageRating }}/5</small></h3>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
  computed: {
    totalPostCount() {
      let postCount = this.$store.getters["admin/getTotalPostCount"];

      return postCount;
    },
    getTotalPostViews() {
      let postViewsCount = this.$store.getters["admin/getTotalPostViews"];

      return postViewsCount;
    },
    averageRating() {
      let averageRating = this.$store.getters["admin/getAveragePostRating"];

      return averageRating;
    }
  },
  created() {
    this.$store.dispatch("admin/getPostCount");
  }
};
</script> 